import { formatDateMMDDYY, YYYYMMDDtoMMDDYY } from '@mummssoftware/utils/formatters';
export const matchTaskWithPlan = (allCppTasks, planId) => allCppTasks && allCppTasks.find(task => Object.keys(task)[0] === planId);
export const filterTaskWithPlan = (allCppTasks, planId) => allCppTasks && allCppTasks.filter(task => Object.keys(task)[0] === planId);
export const getFirstUserCredential = task => {
  const {
    createpersonfirstname,
    createpersonlastname,
    createpersoncredentials
  } = task;

  if (createpersonfirstname && createpersonlastname) {
    if (createpersoncredentials && createpersoncredentials !== 'null') {
      return `${createpersonfirstname} ${createpersonlastname}, ${createpersoncredentials}`;
    }

    return `${createpersonfirstname} ${createpersonlastname}`;
  }

  return ``;
};
export const getLastUserCredential = task => {
  const {
    modifiedpersonfirstname,
    modifiedpersonlastname,
    modifiedpersoncredentials
  } = task;

  if (modifiedpersonfirstname && modifiedpersonlastname) {
    if (modifiedpersoncredentials && modifiedpersoncredentials !== 'null') {
      return `${modifiedpersonfirstname} ${modifiedpersonlastname}, ${modifiedpersoncredentials}`;
    }

    return `${modifiedpersonfirstname} ${modifiedpersonlastname}`;
  }

  return ``;
};
export const getCreatePersonCredential = task => {
  const {
    createpersonfirstname,
    createpersonlastname,
    createpersoncredentials
  } = task;

  if (createpersonfirstname && createpersonlastname) {
    if (createpersoncredentials && createpersoncredentials !== 'null') {
      return `${createpersonfirstname.charAt(0)} ${createpersonlastname}, ${createpersoncredentials}`;
    }

    return `${createpersonfirstname.charAt(0)} ${createpersonlastname}`;
  }

  return ``;
};
export const getModUserCredential = task => {
  const {
    modifiedpersonfirstname,
    modifiedpersonlastname,
    modifiedpersoncredentials
  } = task;

  if (modifiedpersonfirstname && modifiedpersonlastname) {
    if (modifiedpersoncredentials && modifiedpersoncredentials !== 'null') {
      return `${modifiedpersonfirstname.charAt(0)} ${modifiedpersonlastname}, ${modifiedpersoncredentials}`;
    }

    return `${modifiedpersonfirstname.charAt(0)} ${modifiedpersonlastname}`;
  }

  return ``;
};
export const getCPPDate = plan => {
  const {
    resolveddate,
    modifieddatetimeshifted,
    createdatetimeshifted
  } = plan;
  const cppDate = resolveddate && YYYYMMDDtoMMDDYY(resolveddate) || modifieddatetimeshifted && formatDateMMDDYY(modifieddatetimeshifted) || createdatetimeshifted && formatDateMMDDYY(createdatetimeshifted);
  return cppDate;
};